//@ts-nocheck
export const templateReplacer = (templateString: any, templateVariables: any) =>
  templateString.replace(/\${(.*?)}/g, (_, g) => templateVariables[g]);
